import { DayOfTheWeek, LangCode } from "@/lib/gql/__generated__/graphql";

export function dayOfTheWeekConverter(dayOfTheWeek: DayOfTheWeek, lang: LangCode) {
	switch (dayOfTheWeek) {
		case DayOfTheWeek["Mon"]:
			return lang === LangCode.Default ? "月" : "Mon";
		case DayOfTheWeek["Tue"]:
			return lang === LangCode.Default ? "火" : "Tue";
		case DayOfTheWeek["Wed"]:
			return lang === LangCode.Default ? "水" : "Wed";
		case DayOfTheWeek["Thu"]:
			return lang === LangCode.Default ? "木" : "Thu";
		case DayOfTheWeek["Fri"]:
			return lang === LangCode.Default ? "金" : "Fri";
		case DayOfTheWeek["Sat"]:
			return lang === LangCode.Default ? "土" : "Sat";
		case DayOfTheWeek["Sun"]:
			return lang === LangCode.Default ? "日" : "Sun";
		default:
			throw new Error("dayOfTheWeekConverter: Invalid dayOfTheWeek");
	}
}
